import { useState } from 'react';
import { useParams } from 'react-router';
import { TapCardPage } from '@/components/3ds';
import { ActivateCard } from '@/components/Activation';
import { useWorkflow } from '@/hooks/useWorkflow';
import { ActivationsResponse } from '@/types/ActivationResponse';
import { UiPersonLined } from '@cof/omni-gravity-icons-react';
import {
  Button,
  Column,
  Container,
  Flex,
  Icon,
  Row,
  TextHeading,
  TextMetric,
} from '@cof/omni-react';
import { Spinner } from '@cof/omni-react';

export const Activation = ({ isLoading }: { isLoading: boolean }) => {
  const { templateJson } = useWorkflow();
  const { customerDisplayName } = templateJson as ActivationsResponse;
  //const [loading, setLoading] = useState(isLoading);//hookup setLoading when API is integrated.
  const [readyToActivate, setReadyToActivate] = useState(false);
  const { policyProcessId } = useParams();

  return (
    <Container
      padding={'medium'}
      style={{
        background: 'linear-gradient(180deg, #FFF 23.59%, #C5F9CE 88.17%)',
        height: '100vh',
      }}
    >
      {isLoading ? (
        <Row justifyContent={'center'} alignItems={'center'}>
          <Column>
            <Spinner data-testid="Activation--Spinner" size="giant" />
          </Column>
        </Row>
      ) : (
        <>
          {readyToActivate && policyProcessId ? (
            <TapCardPage
              processId={policyProcessId}
              onClose={() => {
                console.log('TapCardPage onClose');
              }}
              onRead={async (airKeyMessage: string) => {
                console.log('TapCardPage');
                console.log(airKeyMessage);
              }}
            />
          ) : (
            <>
              <Container padding={'medium'}>
                <Flex justifyContent={'space-between'}>
                  <TextHeading
                    variant="large"
                    stack="zero"
                    style={{ margin: 0 }}
                  >
                    Hello
                  </TextHeading>
                  <Button
                    variant={'neutral'}
                    rank={'secondary'}
                    size={'small'}
                    type="button"
                    style={{ alignSelf: 'center', padding: '1rem' }}
                    shape={'circle'}
                    aria-label="my account"
                    onClick={(e) => {
                      e.preventDefault();
                      console.log('user profile icon clicked');
                    }}
                  >
                    <Icon svg={UiPersonLined} fill="#0F1010" />
                  </Button>
                </Flex>
                <TextHeading
                  variant="large"
                  fontWeight={'semibold'}
                  stack="medium"
                  style={{ marginTop: 0 }}
                >
                  {customerDisplayName}
                </TextHeading>
                <TextMetric variant={'huge'} stack="large" lineLength="small">
                  You have a new card to activate
                </TextMetric>
              </Container>
              <ActivateCard setReadyToActivate={setReadyToActivate} />
            </>
          )}
        </>
      )}
    </Container>
  );
};
